import styled from 'styled-components';
import ContentBlock from 'src/design/styleguide/contentBlock/ContentBlock';
import { pageShellStyles } from 'src/components/dashboard/common/styles';
import pageContentStyles from 'src/design/components/pageContentBlock/PageContentBlock.mscss';
import headingStyles from 'src/design/components/heading/Heading.mscss';
import { breakpointSmall } from 'src/design/styleguide/common/breakpoints';

const StandaloneAccountShell = styled(ContentBlock).attrs({
  noGutter: true,
  testRef: 'standalone-account-page',
})`
  ${pageShellStyles}

  .container {
    width: 100%;
    padding-right: 0;
    padding-left: 0;
  }

  .${pageContentStyles.root} {
    padding: 0;
  }

  .my-documents,
  .withdraw-success,
  .deposit-success {
    padding-bottom: 0;
  }

  ${breakpointSmall(`
		.my-documents h1,
		.withdraw-success h1,
		.deposit h1 {
			margin-top: 0;
		}

		.${headingStyles.pageHeading} {
			padding-top: 0;
			padding-bottom: 24px;
		}
	`)}
`;

export const StandaloneAccountPage = ({ children }) => (
  <StandaloneAccountShell>{children}</StandaloneAccountShell>
);

const Account = ({ children }) => children;

export default Account;
